import { render } from "./CreatePassword.vue?vue&type=template&id=d67e5272&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"

import "./CreatePassword.vue?vue&type=style&index=0&id=d67e5272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67e5272"]])

export default __exports__